<template>
  <div :class="['ms-form', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid">
        <CustomSelect
          :options="this.data.materialsOptions"
          label="Основной материал"
          :required="true"
          optionValueKey="material_id"
          optionLabelKey="material_name"
          :value="this.formData.material_id || ''"
          @change="(value) => onChange('material_id', value)"
        />

        <CustomInput
          label="ID материала слева"
          type="number"
          :value="this.formData.provider_request_material_id"
          @change_input="(value) => onChange('provider_request_material_id', value)"
          required="true"
        />

        <CustomInput
          label="Цена"
          type="number"
          :value="this.formData.material_price"
          @change_input="(value) => onChange('material_price', value)"
          required="true"
        />

        <CustomInput
          label="Количество"
          type="number"
          :value="this.formData.material_cnt"
          @change_input="(value) => onChange('material_cnt', value)"
          required="true"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import { getProviderRequestInvoiceItem } from "@/views/ProviderRequests/services";

export default {
  name: "provider-requests-invoice-item",
  components: { CustomModalFooter, CustomInput, CustomSelect },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        provider_request_invoice_item_id: '',
        provider_request_id: '',
        material_id: '',
        material_cnt: '',
        material_price: '',
        param_value: '',
        provider_request_material_id: '',
      },
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
    async getData(provider_request_invoice_item_id) {
      const res = await getProviderRequestInvoiceItem(provider_request_invoice_item_id);
      if (res) {
        this.formData = {...this.formData, ...res};
      }
    },
  },
  mounted() {
    if (!!this.data?.provider_request_invoice_item_id) {
      this.getData(this.data?.provider_request_invoice_item_id);
    }
  },
}
</script>
